document.addEventListener('DOMContentLoaded', function () {

    const container = document.querySelector('.product--customizer');
    if (!container) return;

    const sectionId = container.closest('product-info')?.dataset.section;

    const tinBase = container.querySelector('#tin-base');
    const patternLayer = container.querySelector('#tin-pattern');

    if (!tinBase) return;

    const productData = JSON.parse(
        document.querySelector('script[type="application/json"][data-product]')?.textContent || '{}'
    );

    if (!productData.variants) return;

    window.CYK_CUSTOMIZER_PRODUCT = productData;

    let currentColor = null;

    window.getVariantById = function (variantId) {
        return productData.variants.find(function (variant) {
            return String(variant.id) === String(variantId);
        });
    }

    function updateTinImage(variant) {
        if (!variant || !variant.featured_image) return;
        tinBase.src = variant.featured_image.src;
    }

    const initialVariantId = container.querySelector('input[name="id"]')?.value;
    const initialVariant = getVariantById(initialVariantId);

    function updateTotalPrice() {
        const breakdownEl = sectionId
            ? document.getElementById(`cyk-price-breakdown-${sectionId}`)
            : null;

        function clearBreakdown() {
            if (breakdownEl) breakdownEl.textContent = '';
        }

        const variantId = container.querySelector('input[name="id"]')?.value;
        const variant = getVariantById(variantId);
        const qty = parseInt(document.querySelector('.quantity__input')?.value, 10) || 0;

        if (!variant || !qty) {
            clearBreakdown();
        } else {
            const tinSize = cykGetVariantSize(variant, productData) || '—';
            if (breakdownEl) breakdownEl.textContent = '(' + qty + ' x ' + tinSize + ')';
        }

        if (!window.CYK_MONEY_FORMAT || !sectionId) return;

        // variant.price is per tin (Shopify cents); not adjusted for quantity_price_breaks tiers.
        if (!variant || !qty) return;

        const priceEl = document.querySelector(`#price-${sectionId} .price-item--regular`);
        if (priceEl) priceEl.textContent = formatMoney(variant.price * qty, window.CYK_MONEY_FORMAT);
    }

    if (initialVariant) {
        currentColor = cykGetVariantTinColor(initialVariant, productData);
        updateTinImage(initialVariant);

        const minQty = window.cykGetMinQty(initialVariant, productData);
        const qtyInput = document.querySelector('.quantity__input');

        if (qtyInput) {
            qtyInput.min = minQty;
            qtyInput.setAttribute('min', minQty);
            qtyInput.setAttribute('data-min', minQty);
            qtyInput.value = minQty;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateTotalPrice();
    }

    // Update total whenever quantity is manually changed
    const qtyInputForTotal = document.querySelector('.quantity__input');
    if (qtyInputForTotal) {
        qtyInputForTotal.addEventListener('change', function () {
            const variantId = container.querySelector('input[name="id"]')?.value;
            const variant = getVariantById(variantId);
            clampCustomizerQty(qtyInputForTotal, variant);
            updateTotalPrice();
        });
        qtyInputForTotal.addEventListener('input', updateTotalPrice);
    }

    subscribe(PUB_SUB_EVENTS.quantityUpdate, updateTotalPrice);

    const productFormGlobal = container.querySelector('form[data-type="add-to-cart-form"]');
    if (productFormGlobal) {
        setCustomLogoFlag(productFormGlobal, false);

        productFormGlobal.addEventListener('submit', function (event) {
            const result = validateMinQty(container);
            if (!result.valid) {
                event.preventDefault();
                event.stopImmediatePropagation();
                showQtyError(container, `Minimum order is ${result.minQty} tins.`);
            }
        }, true);
    }

    // Variant change
    let lastVariantId = null;

    const variantInput = container.querySelector('input[name="id"]');

    if (variantInput) {
        variantInput.addEventListener('change', function () {
            const newId = variantInput.value;

            if (newId === lastVariantId) return;
            lastVariantId = newId;

            const variant = getVariantById(newId);
            if (!variant) return;

            const color = cykGetVariantTinColor(variant, productData);
            if (color !== currentColor) {
                currentColor = color;
                updateTinImage(variant);
            }

            // Set min qty attrs and value immediately
            const minQty = window.cykGetMinQty(variant, productData);
            const qtyInput = document.querySelector('.quantity__input');

            if (qtyInput) {
                qtyInput.min = minQty;
                qtyInput.setAttribute('min', minQty);
                qtyInput.setAttribute('data-min', minQty);
                qtyInput.value = minQty;
                clearQtyError(container);
            }

            // Trigger qty change after AJAX completes so price-per-item (if ever added)
            // recalculates with the correct pricing tiers for the new variant.
            const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function () {
                unsubscribe();
                updateTotalPrice();
                const qtyInputAfter = document.querySelector('.quantity__input');
                if (qtyInputAfter) {
                    qtyInputAfter.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }

    const CYK_MAX_LOGO_FILE_BYTES = 64 * 1024;

    // Default logo — fetched once on load
    window.CYK_DEFAULT_LOGO_SVG = null;
    if (window.CYK_DEFAULT_LOGO_URL) {
        fetch(window.CYK_DEFAULT_LOGO_URL)
            .then(r => r.text())
            .then(svgText => {
                window.CYK_DEFAULT_LOGO_SVG = svgText;
                refreshCenterContent(container);
            });
    }

    // Pattern helper — updates SVG, restores logo, saves form field
    function applyPattern(type, color1, color2, label) {
        if (!patternLayer || !patterns[type]) return;

        window.CYK_CURRENT_PATTERN_TYPE = type;
        window.CYK_CURRENT_COLOR1 = color1;
        window.CYK_CURRENT_COLOR2 = color2;

        patternLayer.innerHTML = type === 'stripes'
            ? patterns.stripes(color1, color2)
            : patterns.solid(color1, color2);

        let logo = patternLayer.querySelector('#tin-logo');
        if (!logo) {
            logo = document.createElement('div');
            logo.id = 'tin-logo';
            patternLayer.appendChild(logo);
        }

        refreshCenterContent(container);

        const productForm = container.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
            let patternLabelInput = productForm.querySelector('#pattern-label');
            if (!patternLabelInput) {
                patternLabelInput = document.createElement('input');
                patternLabelInput.type = 'hidden';
                patternLabelInput.name = 'properties[Pattern]';
                patternLabelInput.id = 'pattern-label';
                productForm.appendChild(patternLabelInput);
            }
            patternLabelInput.value = label || '';
        }

        window.CYK_CURRENT_PATTERN_LABEL = label || '';
    }

    function refreshCurrentPattern() {
        const type = window.CYK_CURRENT_PATTERN_TYPE;
        const color1 = window.CYK_CURRENT_COLOR1;
        const color2 = window.CYK_CURRENT_COLOR2;
        if (!type || !color1) return;

        const label =
            container.querySelector('#pattern-label')?.value ||
            window.CYK_CURRENT_PATTERN_LABEL ||
            '';

        applyPattern(type, color1, color2, label);
    }

    const presetPatternSwatchSelector = '.pattern-swatch:not(.pattern-swatch--custom)';

    // Pattern swatch click (preset buttons only — custom color cells use native color inputs)
    container.addEventListener('click', function (e) {
        const swatch = e.target.closest('.pattern-swatch');
        if (!swatch || swatch.classList.contains('pattern-swatch--custom')) return;

        container.querySelectorAll(presetPatternSwatchSelector).forEach((s) => s.classList.remove('active'));
        swatch.classList.add('active');

        applyPattern(swatch.dataset.pattern, swatch.dataset.color, swatch.dataset.colorSecondary, swatch.dataset.label);
    });

    function syncCustomPickerSwatch(colorInput) {
        if (!colorInput) return;
        const wrap = colorInput.closest('.custom-swatch-wrapper');
        if (!wrap) return;
        const circle = wrap.querySelector('.swatch-circle');
        if (circle) circle.style.background = colorInput.value;
    }

    const customStripeInput = container.querySelector('#custom-stripe-color');
    const customStripeInput2 = container.querySelector('#custom-stripe-color-2');

    function applyCustomStripesFromInputs() {
        const c1 = customStripeInput?.value || '#0a3e1e';
        const c2 = customStripeInput2?.value || '#dcd8d0';
        container.querySelectorAll(presetPatternSwatchSelector).forEach((s) => s.classList.remove('active'));
        applyPattern('stripes', c1, c2, `Custom Stripes: ${c1} + ${c2}`);
        syncCustomPickerSwatch(customStripeInput);
        syncCustomPickerSwatch(customStripeInput2);
    }

    if (customStripeInput) {
        customStripeInput.addEventListener('input', applyCustomStripesFromInputs);
        customStripeInput.addEventListener('change', applyCustomStripesFromInputs);
    }
    if (customStripeInput2) {
        customStripeInput2.addEventListener('input', applyCustomStripesFromInputs);
        customStripeInput2.addEventListener('change', applyCustomStripesFromInputs);
    }

    const customSolidInput = container.querySelector('#custom-solid-color');
    const customSolidInput2 = container.querySelector('#custom-solid-color-2');

    function applyCustomSolidFromInputs() {
        const c1 = customSolidInput?.value || '#0a3e1e';
        const c2 = customSolidInput2?.value || '#dcd8d0';
        container.querySelectorAll(presetPatternSwatchSelector).forEach((s) => s.classList.remove('active'));
        applyPattern('solid', c1, c2, `Custom Solid: ${c1} + ${c2}`);
        syncCustomPickerSwatch(customSolidInput);
        syncCustomPickerSwatch(customSolidInput2);
    }

    if (customSolidInput) {
        customSolidInput.addEventListener('input', applyCustomSolidFromInputs);
        customSolidInput.addEventListener('change', applyCustomSolidFromInputs);
    }
    if (customSolidInput2) {
        customSolidInput2.addEventListener('input', applyCustomSolidFromInputs);
        customSolidInput2.addEventListener('change', applyCustomSolidFromInputs);
    }

    const firstPattern = container.querySelector(presetPatternSwatchSelector);
    if (firstPattern) firstPattern.click();

    // TEXT
    window.CYK_CUSTOM_TEXT = 'Golden Ossetra';

    const customInput = container.querySelector('#custom-copy');

    if (customInput) {
        customInput.addEventListener('input', function () {
            const value = this.value.trim();
            const text = value || 'Golden Ossetra';

            window.CYK_CUSTOM_TEXT = text;

            const form = container.querySelector('form[data-type="add-to-cart-form"]');
            if (!form) return;

            let textInput = form.querySelector('input[name="properties[Text]"]');

            if (!textInput) {
                textInput = document.createElement('input');
                textInput.type = 'hidden';
                textInput.name = 'properties[Text]';
                form.appendChild(textInput);
            }

            textInput.value = text;

            refreshCurrentPattern();
        });
    }

    // CENTER: LOGO OR TEXT
    window.CYK_CENTER_TYPE = 'logo';
    window.CYK_CENTER_TEXT = '';

    const centerTypeValue = container.querySelector('#center-type-value');
    const centerTextField = container.querySelector('.center-text-field');
    const centerTextInput = container.querySelector('#center-copy');
    const logoUploadPanel = container.querySelector('.logo-upload-panel');

    function setCenterTypeUI(type) {
        const isText = type === 'text';
        window.CYK_CENTER_TYPE = type;

        container.querySelectorAll('.center-type-option').forEach(function (btn) {
            btn.classList.toggle('active', btn.dataset.centerType === type);
        });

        if (centerTypeValue) {
            centerTypeValue.value = isText ? 'Text' : 'Logo';
        }

        if (centerTextField) {
            centerTextField.hidden = !isText;
        }

        if (centerTextInput) {
            centerTextInput.disabled = !isText;
        }

        if (logoUploadPanel) {
            logoUploadPanel.hidden = isText;
        }

        const form = container.querySelector('form[data-type="add-to-cart-form"]');
        if (form && isText) {
            setCustomLogoFlag(form, false);
        }

        refreshCenterContent(container);
    }

    container.addEventListener('click', function (e) {
        const centerTypeBtn = e.target.closest('.center-type-option');
        if (!centerTypeBtn) return;

        const type = centerTypeBtn.dataset.centerType;
        if (!type || type === window.CYK_CENTER_TYPE) return;

        setCenterTypeUI(type);
    });

    if (centerTextInput) {
        centerTextInput.addEventListener('input', function () {
            window.CYK_CENTER_TEXT = this.value.trim();
            updateCenterTextPreview(container);
        });
    }

    const centerTextScaleRange = container.querySelector('#center-text-scale-range');
    const centerTextScaleValueEl = container.querySelector('.center-text-scale-value');

    function syncCenterTextScaleFromRange() {
        const hidden = container.querySelector('input[name="properties[_Center Text Scale]"]');
        if (!centerTextScaleRange || !hidden) return;
        const v = centerTextScaleRange.value;
        hidden.value = v;
        if (centerTextScaleValueEl) {
            centerTextScaleValueEl.textContent = v + '%';
        }
        centerTextScaleRange.setAttribute('aria-valuenow', v);
        applyCenterTextUserScale(container);
    }

    if (centerTextScaleRange) {
        centerTextScaleRange.addEventListener('input', syncCenterTextScaleFromRange);
        centerTextScaleRange.addEventListener('change', syncCenterTextScaleFromRange);
    }

    setCenterTypeUI('logo');

    // FONTS
    window.CYK_FONT = "'Cormorant Garamond', serif";
    window.CYK_LOWER_FONT_SIZE_SOLID = 26;
    window.CYK_LOWER_FONT_SIZE_STRIPES = 22;

    container.addEventListener('click', function (e) {
        const fontOption = e.target.closest('.font-option');
        if (!fontOption) return;

        const font = fontOption.dataset.font;
        if (!font) return;

        window.CYK_FONT = font;
        syncLowerRingFontSizesFromOption(fontOption);

        container.querySelectorAll('.font-option').forEach(f => f.classList.remove('active'));
        fontOption.classList.add('active');

        const form = container.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
            let fontInput = form.querySelector('input[name="properties[Font]"]');

            if (!fontInput) {
                fontInput = document.createElement('input');
                fontInput.type = 'hidden';
                fontInput.name = 'properties[Font]';
                form.appendChild(fontInput);
            }

            // ✅ CLEAN FONT NAME (this is the only real change)
            const cleanedFont = font
                .replace(/['"]/g, '')
                .split(',')[0]
                .trim();

            fontInput.value = cleanedFont;
        }

        refreshCurrentPattern();
        if (isCenterTextMode(container)) {
            updateCenterTextPreview(container);
        }
    });

    // ✅ SET DEFAULT FONT ON LOAD
    const form = container.querySelector('form[data-type="add-to-cart-form"]');
    const activeFontOption = container.querySelector('.font-option.active');

    if (form && activeFontOption) {
        let fontInput = form.querySelector('input[name="properties[Font]"]');

        if (!fontInput) {
            fontInput = document.createElement('input');
            fontInput.type = 'hidden';
            fontInput.name = 'properties[Font]';
            form.appendChild(fontInput);
        }

        const rawFont = activeFontOption.dataset.font;

        const cleanedFont = rawFont
            .replace(/['"]/g, '')
            .split(',')[0]
            .trim();

        fontInput.value = cleanedFont;
    }

    if (activeFontOption) {
        syncLowerRingFontSizesFromOption(activeFontOption);
    }

    // LIGHT COLORS
    document.querySelectorAll(presetPatternSwatchSelector).forEach((swatch) => {
        const color = swatch.dataset.color;
        if (isLightColor(color)) {
            swatch.classList.add('is-light');
        }
    });

    // STRIPE BORDERS
    document.querySelectorAll(`${presetPatternSwatchSelector}.stripes`).forEach((swatch) => {
        const color = swatch.dataset.color;
        if (color) {
            swatch.querySelector('.swatch-circle').style.border = `1px solid ${color}`;
        }
    });

    // LOGO UPLOAD
    const input = container.querySelector('.logo-input');
    const logoRemoveBtn = container.querySelector('.logo-remove');
    const logoScaleRange = container.querySelector('#logo-scale-range');
    const logoScaleValueEl = container.querySelector('.logo-scale-value');
    const logoScaleSection = container.querySelector('.logo-scale-control');

    function setLogoRemoveVisible(visible) {
        if (!logoRemoveBtn) return;
        logoRemoveBtn.hidden = !visible;
    }

    function setLogoScaleSectionVisible(visible) {
        if (!logoScaleSection) return;
        logoScaleSection.hidden = !visible;
        if (visible) {
            const hidden = container.querySelector('input[name="properties[_Logo Scale]"]');
            const v = (hidden && hidden.value) || '100';
            if (logoScaleRange) {
                logoScaleRange.value = v;
                logoScaleRange.setAttribute('aria-valuenow', v);
            }
            if (logoScaleValueEl) {
                logoScaleValueEl.textContent = v + '%';
            }
        }
    }

    function syncLogoScaleFromRange() {
        const hidden = container.querySelector('input[name="properties[_Logo Scale]"]');
        if (!logoScaleRange || !hidden) return;
        const v = logoScaleRange.value;
        hidden.value = v;
        if (logoScaleValueEl) {
            logoScaleValueEl.textContent = v + '%';
        }
        logoScaleRange.setAttribute('aria-valuenow', v);
        applyLogoUserScale(container);
    }

    function resetLogoScale() {
        const hidden = container.querySelector('input[name="properties[_Logo Scale]"]');
        if (hidden) hidden.value = '100';
        if (logoScaleRange) {
            logoScaleRange.value = '100';
            logoScaleRange.setAttribute('aria-valuenow', '100');
        }
        if (logoScaleValueEl) {
            logoScaleValueEl.textContent = '100%';
        }
        applyLogoUserScale(container);
    }

    if (logoScaleRange) {
        logoScaleRange.addEventListener('input', syncLogoScaleFromRange);
        logoScaleRange.addEventListener('change', syncLogoScaleFromRange);
    }

    function clearUploadedLogo() {
        const form = container.querySelector('form[data-type="add-to-cart-form"]');
        const hiddenSvg = container.querySelector('input[name="properties[_Logo SVG]"]');
        const hiddenPng = container.querySelector('input[name="properties[_Logo PNG]"]');
        if (hiddenSvg) hiddenSvg.value = '';
        if (hiddenPng) hiddenPng.value = '';

        if (input) input.value = '';

        setCustomLogoFlag(form, false);

        resetLogoScale();
        setLogoScaleSectionVisible(false);

        if (window.CYK_DEFAULT_LOGO_SVG) {
            refreshCenterContent(container);
        }

        const uploadText = container.querySelector('.upload-text');
        if (uploadText) uploadText.textContent = 'Upload file';

        setLogoRemoveVisible(false);
    }

    if (logoRemoveBtn) {
        logoRemoveBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            clearUploadedLogo();
        });
    }

    if (input) {
        input.addEventListener('change', function (e) {
            const file = e.target.files[0];
            if (!file) return;

            const isSvg =
                file.type === 'image/svg+xml' ||
                /\.svg$/i.test(file.name || '');
            const isPng =
                file.type === 'image/png' ||
                /\.png$/i.test(file.name || '');

            if (!isSvg && !isPng) {
                alert('Please upload an SVG or PNG file.');
                e.target.value = '';
                return;
            }

            if (file.size > CYK_MAX_LOGO_FILE_BYTES) {
                alert(
                    'Logo files must be ' +
                        Math.floor(CYK_MAX_LOGO_FILE_BYTES / 1024) +
                        ' KB or smaller (cart line item limit).'
                );
                e.target.value = '';
                return;
            }

            const form = container.querySelector('form[data-type="add-to-cart-form"]');
            if (!form) return;

            if (isSvg) {
                const reader = new FileReader();
                reader.onload = function (event) {
                    const svgText = event.target.result;
                    const hiddenSvg = ensureHiddenLogoField(form, 'properties[_Logo SVG]');
                    hiddenSvg.value = svgText;
                    const hiddenPng = form.querySelector('input[name="properties[_Logo PNG]"]');
                    if (hiddenPng) hiddenPng.value = '';
                    updateLogoPreview(svgText, 'svg');
                    setCustomLogoFlag(form, true);
                    setLogoScaleSectionVisible(true);
                    const uploadText = container.querySelector('.upload-text');
                    if (uploadText) uploadText.textContent = file.name;
                    setLogoRemoveVisible(true);
                };
                reader.readAsText(file);
            } else {
                const reader = new FileReader();
                reader.onload = function (event) {
                    const dataUrl = event.target.result;
                    const hiddenPng = ensureHiddenLogoField(form, 'properties[_Logo PNG]');
                    hiddenPng.value = dataUrl;
                    const hiddenSvg = form.querySelector('input[name="properties[_Logo SVG]"]');
                    if (hiddenSvg) hiddenSvg.value = '';
                    updateLogoPreview(dataUrl, 'png');
                    setCustomLogoFlag(form, true);
                    setLogoScaleSectionVisible(true);
                    const uploadText = container.querySelector('.upload-text');
                    if (uploadText) uploadText.textContent = file.name;
                    setLogoRemoveVisible(true);
                };
                reader.readAsDataURL(file);
            }
        });
    }

    // DATE NEEDED
    const dateInput = container.querySelector('.delivery-date-input');

    if (dateInput) {
        const form = container.querySelector('form[data-type="add-to-cart-form"]');

        if (form) {
            let dateField = form.querySelector('input[name="properties[Date Needed]"]');

            if (!dateField) {
                dateField = document.createElement('input');
                dateField.type = 'hidden';
                dateField.name = 'properties[Date Needed]';
                form.appendChild(dateField);
            }

            // block dates within the next 2 weeks
            const minDate = new Date();
            minDate.setDate(minDate.getDate() + 14);
            dateInput.min = minDate.toISOString().split('T')[0];

            // update value, clamping manual input to min date
            dateInput.addEventListener('change', function () {
                if (this.value && this.value < dateInput.min) {
                    this.value = dateInput.min;
                }
                dateField.value = this.value;
            });
        }
    }

    container.querySelectorAll('.tab-link').forEach(btn => {
        btn.addEventListener('click', () => {
            const tab = btn.dataset.tab;
            container.querySelectorAll('.tab-link').forEach(b => b.classList.remove('active'));
            container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
            container.querySelector(`.tab-link[data-tab="${tab}"]`)?.classList.add('active');
            container.querySelector(`[data-panel="${tab}"]`)?.classList.add('active');
        });
    });

    function scrollToProductInfoTop() {
        const productInfo = container.querySelector('[id^="ProductInfo-"]');
        if (!productInfo) return;

        const headerOffset =
            parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = productInfo.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    container.querySelectorAll('.step-next').forEach(btn => {
        btn.addEventListener('click', () => {
            const nextStep = btn.dataset.next;

            // 🚫 ONLY validate when leaving Step 1
            const currentPanel = btn.closest('.tab-panel');

            if (currentPanel?.dataset.panel === 'step-1') {
                const result = validateMinQty(container);

                if (!result.valid) {
                    showQtyError(container, `Minimum order is ${result.minQty} tins.`);
                    return;
                } else {
                    clearQtyError(container);
                }
            }

            // 🔁 Switch tabs (reuse your system)
            container.querySelectorAll('.tab-link').forEach(b => b.classList.remove('active'));
            container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

            container.querySelector(`.tab-link[data-tab="${nextStep}"]`)?.classList.add('active');
            container.querySelector(`[data-panel="${nextStep}"]`)?.classList.add('active');

            scrollToProductInfoTop();
        });
    });

}); // END DOM LOAD


// ✅ ADD HELPER (only new function)
function setCustomLogoFlag(form, hasLogo) {
    if (!form) return;

    let input = form.querySelector('input[name="properties[Custom Logo]"]');

    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Custom Logo]';
        form.appendChild(input);
    }

    input.value = hasLogo ? 'Yes' : 'No';
}

function getCustomLogoPayload(container) {
    if (!container) return null;
    const png = container.querySelector('input[name="properties[_Logo PNG]"]')?.value?.trim();
    if (png) return { kind: 'png', data: png };
    const svg = container.querySelector('input[name="properties[_Logo SVG]"]')?.value?.trim();
    if (svg) return { kind: 'svg', data: svg };
    return null;
}

function ensureHiddenLogoField(form, name) {
    const existing = Array.from(form.querySelectorAll('input[type="hidden"]')).find(function (el) {
        return el.name === name;
    });
    if (existing) return existing;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
    return input;
}

function inferLogoKind(logoInput) {
    if (typeof logoInput === 'string' && /^\s*data:image\/png/i.test(logoInput)) {
        return 'png';
    }
    return 'svg';
}

function escapeSvgTextContent(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function getBottomRingDisplayText() {
    const el = document.querySelector('.product--customizer #custom-copy');
    const trimmed = (el?.value ?? '').trim();
    if (trimmed === '') {
        return 'Golden Ossetra'.toUpperCase();
    }
    return escapeSvgTextContent(trimmed);
}

function syncLowerRingFontSizesFromOption(fontOptionEl) {
    if (!fontOptionEl || !fontOptionEl.dataset) return;
    const solid = parseInt(fontOptionEl.dataset.lowerSolid, 10);
    const stripes = parseInt(fontOptionEl.dataset.lowerStripes, 10);
    window.CYK_LOWER_FONT_SIZE_SOLID = Number.isFinite(solid) && solid > 0 ? solid : 26;
    window.CYK_LOWER_FONT_SIZE_STRIPES = Number.isFinite(stripes) && stripes > 0 ? stripes : 22;
}

function getLowerRingFontSizeSolid() {
    const n = window.CYK_LOWER_FONT_SIZE_SOLID;
    return typeof n === 'number' && n > 0 ? n : 26;
}

function getLowerRingFontSizeStripes() {
    const n = window.CYK_LOWER_FONT_SIZE_STRIPES;
    return typeof n === 'number' && n > 0 ? n : 22;
}

// Upper "CYK CAVIAR" paths — solid tin only (assets/solid-tin-upper-text.svg, 693.26 → 478). Stripes use textPath on the ring arc.
const CYK_CAVIAR_UPPER = {"scale":0.6894960043850792,"tcx":346.63,"tcy":346.63,"paths":["M161.11,112.95c1.85-1.13,3.43-1.91,4.74-2.34.39-.16.68-.2.89-.13.21.07.47.27.8.6l6.21,6.14c.08.1.05.23-.1.4-.14.17-.3.23-.48.15-3.14-1.84-6.17-2.73-9.1-2.66s-5.63,1.14-8.12,3.2c-2.32,1.92-3.9,4.22-4.75,6.9s-.89,5.54-.12,8.59c.77,3.04,2.37,6.03,4.79,8.95,2.45,2.96,5.13,5.1,8.05,6.44,2.92,1.34,5.83,1.83,8.71,1.47,2.89-.36,5.56-1.56,8.01-3.59,2.35-1.95,3.83-4.18,4.43-6.71s.48-5.77-.38-9.71c-.05-.12.03-.24.23-.35.2-.11.33-.12.42-.02l4.18,6.61c.25.44.39.75.41.92s-.06.44-.26.83c-2.26,3.65-4.99,6.81-8.18,9.46-3.64,3.02-7.44,5.07-11.4,6.16-3.96,1.08-7.72,1.13-11.3.14s-6.6-2.98-9.07-5.96c-2.53-3.05-3.94-6.47-4.23-10.26-.3-3.79.47-7.58,2.3-11.37s4.55-7.18,8.16-10.17c1.6-1.33,3.33-2.55,5.18-3.68h-.02Z","M213.07,80.93c.13.22.15.35.07.39-1.19.69-2.24,2.22-3.16,4.61s-1.45,5.01-1.58,7.88l-.53,12.87,6.97,12.08c.65,1.12,1.21,1.88,1.7,2.27.48.4,1.05.52,1.71.38.66-.14,1.6-.56,2.83-1.27.11-.07.23,0,.36.22.12.22.13.36.02.42-1.26.73-2.27,1.29-3.02,1.67l-4.34,2.43-4.22,2.51c-.75.48-1.77,1.09-3.07,1.85-.08.04-.18-.04-.3-.26-.13-.22-.15-.35-.07-.39,1.23-.71,2.07-1.32,2.54-1.83.47-.51.66-1.09.57-1.74-.09-.64-.45-1.51-1.08-2.59l-6.32-10.94-15.49-7.45c-2.63-1.27-4.64-2.05-6.05-2.32-1.41-.27-2.44-.22-3.09.16-.12.07-.24,0-.36-.23-.13-.22-.13-.36-.01-.42l1.81-.97c.88-.41,1.5-.72,1.84-.92,1.34-.77,3.25-1.93,5.74-3.46l3.76-2.24c.08-.04.18.04.3.26s.15.35.07.39c-.65.38-1.07.81-1.27,1.31-.2.5-.16.98.11,1.45.33.58,1,1.11,1.99,1.59l14.63,7.15.37-11.56c.1-2.22-.19-3.91-.86-5.07-.5-.87-1.16-1.36-1.97-1.49-.82-.13-1.74.1-2.78.7-.12.07-.24,0-.36-.23s-.13-.36-.01-.42l3.08-1.7c1.8-.94,3.39-1.82,4.77-2.61.65-.38,1.42-.86,2.29-1.47l2.09-1.28c.08-.04.18.04.3.26h.02Z","M275.48,97.74c.09.23.07.37-.05.42l-6.96,2.6c-.66.25-1.21.48-1.66.69s-.81.37-1.1.48c-.66.25-1.29.31-1.87.2-.59-.11-1.37-.43-2.34-.96s-2.75-1.58-5.32-3.15c-.31-.19-.66-.41-1.05-.64-.39-.23-.84-.5-1.33-.81l-11.99-7.27-.89,1.8,4.77,12.77c.45,1.21.88,2.05,1.29,2.52s.95.69,1.63.66c.67-.03,1.67-.29,3-.79.16-.06.29.02.38.26.09.23.05.38-.12.44-1.37.51-2.45.89-3.25,1.15l-4.68,1.68-4.58,1.78c-.82.35-1.93.79-3.33,1.31-.08.03-.17-.07-.26-.31-.09-.23-.09-.37,0-.4,1.33-.5,2.26-.96,2.81-1.38s.83-.97.85-1.62c.02-.65-.19-1.56-.63-2.74l-10.13-27.13c-.44-1.17-.87-1.99-1.3-2.45s-.99-.69-1.67-.68c-.68,0-1.66.25-2.95.73-.12.05-.23-.05-.32-.28s-.07-.37.06-.42l3.32-1.17c1.93-.63,3.46-1.16,4.58-1.58,1.24-.46,2.8-1.09,4.68-1.88l3.15-1.24c.12-.05.23.05.32.28s.07.37-.06.42c-1.28.48-2.18.95-2.7,1.41-.51.46-.78,1.01-.79,1.66-.02.65.19,1.56.63,2.74l4.64,12.42,7.49-15.61c.78-1.58.99-2.84.64-3.78-.26-.7-.8-1.13-1.61-1.27s-1.81,0-3.02.46c-.12.05-.23-.05-.32-.28s-.07-.37.06-.42l2.94-1.03c1.85-.6,3.56-1.2,5.14-1.79,1.7-.63,3.44-1.33,5.24-2.09l2.77-1.1c.12-.05.23.05.32.28s.07.37-.05.42c-1.91.71-3.81,2.01-5.7,3.9s-3.45,4.04-4.67,6.45l-4.51,9.36,13.57,8.28c4.05,2.63,7.03,4.44,8.94,5.44s3.35,1.53,4.31,1.59c.97.06,2.09-.15,3.38-.63.12-.05.23.05.32.28l-.02.02Z","M326.59,50.37c2.17.08,3.91.3,5.24.66.41.08.68.21.81.39.13.17.24.49.34.94l1.79,8.55c.01.12-.09.22-.3.28-.22.07-.38.02-.48-.14-1.6-3.27-3.64-5.68-6.12-7.23-2.48-1.56-5.33-2.16-8.54-1.81-2.99.32-5.58,1.37-7.77,3.13-2.19,1.77-3.8,4.13-4.84,7.1-1.04,2.96-1.35,6.33-.94,10.1.41,3.81,1.47,7.09,3.16,9.82,1.7,2.73,3.85,4.74,6.46,6.03s5.49,1.76,8.66,1.42c3.03-.33,5.5-1.38,7.4-3.16s3.58-4.55,5.04-8.31c.03-.13.16-.18.38-.17.22.02.34.09.36.21l-.16,7.82c-.04.51-.09.84-.16.99-.07.16-.3.34-.68.54-3.9,1.8-7.91,2.93-12.05,3.38-4.71.51-9.01.12-12.9-1.15-3.9-1.28-7.06-3.31-9.5-6.11s-3.86-6.12-4.28-9.98c-.43-3.94.28-7.57,2.12-10.89,1.84-3.32,4.57-6.06,8.19-8.21,3.61-2.15,7.75-3.48,12.41-3.98,2.07-.22,4.18-.3,6.35-.21h0Z","M391.28,91.32c-.02.25-.14.37-.36.35-.88-.06-2.25-.21-4.09-.43-1.94-.23-3.32-.37-4.16-.43-1.1-.08-2.45-.14-4.05-.17-1.51-.03-2.7-.07-3.58-.14-.18,0-.25-.14-.24-.39.02-.25.12-.37.29-.35,1.15.08,1.98.03,2.51-.16.52-.19.81-.58.85-1.16.05-.71-.3-1.92-1.06-3.65l-3.88-8.75-16.28-1.2-2.98,5.24c-.66,1.16-1.03,2.27-1.11,3.3-.11,1.5.37,2.7,1.43,3.62s2.54,1.44,4.44,1.58c.22.02.32.15.3.4-.02.25-.14.37-.36.35-.79-.06-1.94-.18-3.43-.38-1.67-.21-3.12-.36-4.36-.45-1.19-.09-2.63-.15-4.31-.19-1.51-.03-2.72-.08-3.65-.14-.18,0-.26-.14-.24-.39s.12-.37.29-.36c1.23.09,2.29-.07,3.16-.49s1.77-1.21,2.7-2.37c.93-1.16,2.05-2.91,3.38-5.24l16.55-28.69c.1-.12.3-.17.61-.14.35.03.55.1.58.23l14.28,31.9c1.33,3.07,2.46,5.2,3.39,6.4s1.95,1.84,3.05,1.92c.22.02.32.15.3.4l.03-.02ZM358.22,73.15l14.42,1.06-6.56-14.78-7.86,13.72h0Z","M439.69,63.8c-.06.24-.15.35-.28.32-1.55-.37-3.19-.06-4.91.9-1.73.97-3.28,2.44-4.65,4.43l-19.02,27.26c-.08.15-.34.18-.77.08s-.65-.24-.65-.41l-8.72-36.81c-.43-1.64-.95-2.91-1.56-3.81-.61-.89-1.39-1.45-2.33-1.67-.13-.03-.17-.17-.11-.41s.15-.35.28-.32c.64.15,1.09.28,1.34.38.84.28,1.95.59,3.33.91,3.7.87,6.86,1.57,9.46,2.1.7.12,1.56.3,2.6.55.13.03.17.17.11.41s-.15.35-.28.32c-1.29-.3-2.35-.29-3.18.06-.83.34-1.36.98-1.57,1.91-.16.69-.12,1.58.12,2.66l5.89,25.09,13.31-18.91c.7-1.03,1.14-1.96,1.33-2.77.3-1.26.13-2.35-.49-3.26-.63-.92-1.69-1.55-3.2-1.91-.13-.03-.17-.17-.11-.41s.15-.35.28-.32l3.15.8c1.79.51,3.39.93,4.82,1.26.82.19,1.84.39,3.06.59l2.66.56c.13.03.17.17.11.41h-.02Z","M448.2,106.34c0,.62.26,1.15.78,1.57s1.45.89,2.77,1.4c.12.05.14.19.05.42s-.2.33-.32.28c-1.36-.52-2.43-.95-3.2-1.29l-4.69-1.86-4.61-1.7c-.84-.28-1.96-.69-3.37-1.22-.08-.03-.08-.16.01-.4.09-.23.17-.33.26-.3,1.32.51,2.33.78,3.02.82s1.26-.17,1.71-.65c.44-.48.89-1.3,1.34-2.47l10.36-27.04c.45-1.17.66-2.07.64-2.7-.02-.63-.3-1.17-.83-1.62s-1.47-.93-2.79-1.44c-.08-.03-.08-.16.01-.4.09-.23.17-.33.26-.3l3.32,1.34c1.87.81,3.38,1.43,4.54,1.87,1.28.49,2.88,1.06,4.82,1.71l3.18,1.15c.12.05.14.19.05.42s-.2.33-.32.28c-1.28-.49-2.28-.74-2.98-.74s-1.28.24-1.7.72c-.42.49-.86,1.31-1.3,2.48l-10.32,26.92c-.46,1.21-.7,2.12-.7,2.75h0Z","M499.26,134.45c-.12.22-.28.27-.47.17-.77-.43-1.95-1.13-3.53-2.11-1.66-1.02-2.86-1.73-3.59-2.14-.97-.54-2.16-1.16-3.6-1.86-1.35-.66-2.42-1.2-3.19-1.63-.15-.09-.17-.24-.05-.46s.26-.29.41-.2c1,.56,1.79.86,2.34.91.55.05.97-.18,1.26-.69.34-.62.54-1.87.57-3.76l.16-9.57-14.26-7.93-4.91,3.5c-1.09.78-1.89,1.62-2.39,2.53-.73,1.31-.8,2.61-.22,3.88.58,1.28,1.7,2.38,3.36,3.3.19.11.23.27.11.49s-.28.28-.47.17c-.7-.39-1.68-.98-2.95-1.79-1.43-.89-2.68-1.64-3.77-2.24-1.04-.58-2.32-1.24-3.83-1.99-1.36-.66-2.44-1.21-3.25-1.67-.15-.08-.17-.24-.05-.46s.26-.28.42-.2c1.08.6,2.11.9,3.07.89.97,0,2.12-.35,3.45-1.01,1.33-.67,3.09-1.78,5.27-3.33l27.08-19.07c.14-.07.34-.02.61.13.31.17.45.32.43.45l-.46,34.95c-.09,3.34.04,5.75.38,7.23s1,2.48,1.96,3.02c.19.11.23.27.11.49ZM476.92,104.05l12.64,7.03.26-16.17-12.9,9.14Z","M537.01,165.61c-.16.19-.27.26-.34.2l-9.09-7.53c-.75-.62-1.09-3.05-1.02-7.3.07-4.24.56-9.86,1.47-16.85-.3-.19-.7-.5-1.21-.93-1.33-1.1-2.25-1.89-2.77-2.38l-8.82,10.64c-.82,1-1.34,1.79-1.54,2.38-.2.59-.12,1.17.24,1.74.36.57,1.08,1.31,2.18,2.21.07.06.02.18-.14.37-.16.19-.27.26-.34.2-1.12-.93-2-1.68-2.62-2.25l-3.84-3.26-3.77-3.04c-.71-.53-1.64-1.28-2.8-2.24-.1-.09-.07-.22.09-.42.16-.19.29-.25.39-.16,1.09.9,1.95,1.48,2.58,1.73s1.23.22,1.8-.09,1.26-.95,2.05-1.91l18.47-22.3c.8-.96,1.3-1.74,1.5-2.33s.12-1.19-.24-1.79-1.08-1.34-2.13-2.21c-.07-.06-.02-.18.14-.37.16-.19.27-.26.34-.2l2.67,2.29c1.51,1.36,2.73,2.43,3.65,3.19,1.16.96,2.4,1.91,3.75,2.86.47.33,1.05.76,1.74,1.28s1.44,1.12,2.26,1.79c3.1,2.57,5.05,5.09,5.87,7.58.81,2.49.42,4.69-1.18,6.62-1.46,1.77-3.3,2.94-5.5,3.52-2.21.58-4.52.6-6.94.06-.47,6.11-.69,11.02-.66,14.73.03,3.71.35,6.65.96,8.83.61,2.18,1.59,3.83,2.95,4.96.07.06.02.18-.14.37h0ZM527.97,132.13c1.97,1.64,3.83,2.29,5.56,1.97s3.56-1.64,5.47-3.95c2.18-2.63,3.27-4.79,3.28-6.46,0-1.67-.76-3.14-2.29-4.41-1.36-1.13-2.53-1.69-3.51-1.69s-1.93.57-2.86,1.69l-8.46,10.21c.71.81,1.65,1.69,2.8,2.65h.01Z"]};


function cykCaviarUpperPathsMarkup(letterFill) {
    const u = CYK_CAVIAR_UPPER;
    const tf = 'translate(239,239) scale(' + u.scale + ') translate(' + (-u.tcx) + ',' + (-u.tcy) + ')';
    let html = '<g transform="' + tf + '">';
    for (let i = 0; i < u.paths.length; i++) {
        html += '<path fill="' + letterFill + '" d="' + u.paths[i] + '"/>';
    }
    html += '</g>';
    return html;
}

// Upper ring brand text — not driven by font picker (bottom custom text still uses CYK_FONT).
const CYK_TOP_CURVE_FONT = "'Cormorant Garamond', serif";

// PATTERNS (REMOVED SVG LOGO IMAGE)
const patterns = {

    solid: function (color1, color2) {
        const clipId = 'clip-' + Date.now();
        const bottomCurveId = 'bottom-curve-' + (Date.now() + 1);
        const font = window.CYK_FONT || "'Cormorant Garamond', serif";
        const lowerFontSize = getLowerRingFontSizeSolid();
        const inner = color2 || '#dcd8d0';

        return `
        <svg viewBox="0 0 478 478" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <clipPath id="${clipId}">
                <circle cx="239" cy="239" r="239"/>
            </clipPath>
            <path id="${bottomCurveId}" d="M 46 249 A 193 193 0 0 0 432 249"/>
        </defs>
        <g clip-path="url(#${clipId})">
            <circle cx="239" cy="239" r="239" fill="${color1}"/>
            <circle cx="239" cy="239" r="148" fill="${inner}"/>
            <circle cx="239" cy="239" r="139" fill="none" stroke="${color1}" stroke-width="3"/>
        </g>

        ${cykCaviarUpperPathsMarkup(inner)}

        <text font-size="${lowerFontSize}" fill="${inner}" text-anchor="middle"
              letter-spacing="2" font-family="${font}">
            <textPath href="#${bottomCurveId}" startOffset="50%">
                ${getBottomRingDisplayText()}
            </textPath>
        </text>
        </svg>
        `;
    },

    stripes: function (color1, color2) {
        const clipId = 'clip-' + Date.now();
        const topCurveId = 'top-curve-' + Date.now();
        const bottomCurveId = 'bottom-curve-' + (Date.now() + 1);
        const font = window.CYK_FONT || "'Cormorant Garamond', serif";
        const lowerFontSize = getLowerRingFontSizeStripes();

        return `
        <svg viewBox="0 0 478 478" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#${clipId})">
            <rect width="478" height="478" rx="239" fill="${color2}"/>
            <rect x="62" y="-214" width="71" height="709" fill="${color1}"/>
            <rect x="212" y="-214" width="70" height="709" fill="${color1}"/>
            <rect x="345" y="-214" width="71" height="709" fill="${color1}"/>

            <circle cx="239" cy="239" r="155" fill="${color2}"/>
            <circle cx="238.5" cy="238.5" r="97.5" fill="${color1}"/>
        </g>

        <text font-size="36" fill="${color1}" text-anchor="middle"
              letter-spacing="2" font-family="${CYK_TOP_CURVE_FONT}">
            <textPath href="#${topCurveId}" startOffset="50%">
                CYK CAVIAR
            </textPath>
        </text>

        <text font-size="${lowerFontSize}" fill="${color1}" text-anchor="middle"
              letter-spacing="2" font-family="${font}">
            <textPath href="#${bottomCurveId}" startOffset="50%">
                ${getBottomRingDisplayText()}
            </textPath>
        </text>

        <defs>
            <clipPath id="${clipId}">
                <rect width="478" height="478" rx="239"/>
            </clipPath>
            <path id="${topCurveId}" d="M 116 249 A 118 118 0 0 1 362 249"/>
            <path id="${bottomCurveId}" d="M 116 249 A 118 118 0 0 0 362 249"/>
        </defs>
        </svg>
        `;
    }
};


function recolorSvg(svgText, color) {
    return svgText
        .replace(/fill="(?!none")[^"]*"/gi,   `fill="${color}"`)
        .replace(/stroke="(?!none")[^"]*"/gi, `stroke="${color}"`)
        .replace(/(fill\s*:\s*)(?!none)[^;}"]+/gi,   `$1${color}`)
        .replace(/(stroke\s*:\s*)(?!none)[^;}"]+/gi, `$1${color}`);
}

function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.floor(cents / 100).toString())
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
}

function isLightColor(hex) {
    if (!hex) return false;
    hex = hex.replace('#', '');

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 200;
}

function applyLogoUserScale(container) {
    if (!container) {
        container = document.querySelector('.product--customizer');
    }
    if (!container) return;

    const prop = container.querySelector('input[name="properties[_Logo Scale]"]');
    let pct = parseInt(prop && prop.value, 10);
    if (!Number.isFinite(pct)) {
        pct = 100;
    }
    pct = Math.min(120, Math.max(50, pct));

    const logo = document.querySelector('.product--customizer #tin-pattern #tin-logo');
    if (!logo) return;

    logo.style.setProperty('--logo-user-scale', String(pct / 100));
}

function applyCenterTextUserScale(container) {
    if (!container) {
        container = document.querySelector('.product--customizer');
    }
    if (!container) return;

    const prop = container.querySelector('input[name="properties[_Center Text Scale]"]');
    let pct = parseInt(prop && prop.value, 10);
    if (!Number.isFinite(pct)) {
        pct = 100;
    }
    pct = Math.min(120, Math.max(50, pct));

    const tinText = container.querySelector('#tin-text');
    if (!tinText) return;

    tinText.style.setProperty('--center-text-user-scale', String(pct / 100));
}

function isCenterTextMode(container) {
    if (!container) {
        container = document.querySelector('.product--customizer');
    }
    return window.CYK_CENTER_TYPE === 'text';
}

function getCenterTextColor() {
    const isSolid = window.CYK_CURRENT_PATTERN_TYPE === 'solid';
    if (isSolid) {
        return window.CYK_CURRENT_COLOR1 || '#0a3e1e';
    }
    return window.CYK_CURRENT_COLOR2 || '#dcd8d0';
}

function getCenterTextDisplayText() {
    const trimmed = (window.CYK_CENTER_TEXT || '').trim();
    return trimmed || 'Your Text Here';
}

function updateCenterTextPreview(container) {
    if (!container) {
        container = document.querySelector('.product--customizer');
    }
    if (!container) return;

    const tinText = container.querySelector('#tin-text');
    const span = tinText?.querySelector('span');
    if (!tinText || !span) return;

    span.textContent = getCenterTextDisplayText();

    const font = window.CYK_FONT || "'Cormorant Garamond', serif";
    span.style.fontFamily = font;
    span.style.color = getCenterTextColor();
    applyCenterTextUserScale(container);

    tinText.hidden = false;
}

function refreshCenterContent(container) {
    if (!container) {
        container = document.querySelector('.product--customizer');
    }
    if (!container) return;

    const logo = container.querySelector('#tin-pattern #tin-logo');
    const tinText = container.querySelector('#tin-text');

    if (isCenterTextMode(container)) {
        if (logo) {
            logo.replaceChildren();
            logo.style.display = 'none';
        }
        updateCenterTextPreview(container);
        return;
    }

    if (tinText) {
        tinText.hidden = true;
    }

    const customLogo = getCustomLogoPayload(container);
    if (customLogo) {
        updateLogoPreview(customLogo.data, customLogo.kind);
    } else if (window.CYK_DEFAULT_LOGO_SVG) {
        updateLogoPreview(window.CYK_DEFAULT_LOGO_SVG, 'svg');
    } else if (logo) {
        logo.replaceChildren();
        logo.style.display = 'none';
    }
}

function updateLogoPreview(logoInput, kind) {
    const logo = document.querySelector('.product--customizer #tin-pattern #tin-logo');
    if (!logo) return;

    const resolvedKind = kind || inferLogoKind(logoInput);
    const isSolid = window.CYK_CURRENT_PATTERN_TYPE === 'solid';
    const logoSize = isSolid ? '88%' : '64%';

    if (resolvedKind === 'png') {
        logo.replaceChildren();
        const img = document.createElement('img');
        img.src = logoInput;
        img.alt = '';
        img.decoding = 'async';
        img.style.objectFit = 'contain';
        logo.appendChild(img);
        logo.style.display = 'flex';

        img.style.width = logoSize;
        img.style.height = logoSize;
        applyLogoUserScale(document.querySelector('.product--customizer'));
        return;
    }

    const color1 = window.CYK_CURRENT_COLOR1;
    const logoColor = isSolid ? color1 : window.CYK_CURRENT_COLOR2;
    const rendered = logoColor ? recolorSvg(logoInput, logoColor) : logoInput;

    logo.innerHTML = rendered;
    logo.style.display = 'flex';

    const svg = logo.querySelector('svg');
    if (!svg) {
        applyLogoUserScale(document.querySelector('.product--customizer'));
        return;
    }

    svg.removeAttribute('width');
    svg.removeAttribute('height');

    svg.style.width = logoSize;
    svg.style.height = logoSize;

    applyLogoUserScale(document.querySelector('.product--customizer'));
}

function validateMinQty(container) {
    const variantId = container.querySelector('input[name="id"]')?.value;
    const variant = getVariantById(variantId);
    const product = window.CYK_CUSTOMIZER_PRODUCT;

    const qtyInput = container.querySelector('input[name="quantity"]');
    const qty = parseInt(qtyInput?.value || 0, 10);

    const minQty = window.cykGetMinQty(variant, product);

    if (qty < minQty) {
        return { valid: false, minQty };
    }

    return { valid: true };
}

function clampCustomizerQty(qtyInput, variant) {
    if (!qtyInput || !variant) return;

    const product = window.CYK_CUSTOMIZER_PRODUCT;
    const minQty = window.cykGetMinQty(variant, product);
    const qty = parseInt(qtyInput.value, 10);

    if (Number.isNaN(qty) || qty < minQty) {
        qtyInput.value = minQty;
        qtyInput.min = minQty;
        qtyInput.setAttribute('min', minQty);
        qtyInput.setAttribute('data-min', minQty);
    }
}

function showQtyError(container, message) {
    const errorEl = container.querySelector('.qty-error');
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.style.display = 'block';
}

function clearQtyError(container) {
    const errorEl = container.querySelector('.qty-error');
    if (!errorEl) return;

    errorEl.textContent = '';
    errorEl.style.display = 'none';
}
